// extracted by mini-css-extract-plugin
export default {"interim-fixed-footer":"FixedInterimView_interim-fixed-footer__Pu3Jg","interim-fixed-content":"FixedInterimView_interim-fixed-content__busit"};